import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/contact', label: 'Contact' },
    { to: '/membership', label: 'Membership' },
  ];


  return (
    <>
      {/* <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-amber-50/95 backdrop-blur-sm shadow-md border-b border-amber-200'
            : 'bg-transparent'
        }`}
      > */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/80 backdrop-blur-xl shadow-lg border-b border-amber-200/50 rounded-b-2xl -mx-6 px-6'
            : 'bg-transparent'
        }`}
        style={{
          background: scrolled
            ? 'linear-gradient(135deg, rgba(255, 251, 240, 0.9) 0%, rgba(254, 243, 199, 0.85) 100%)'
            : 'transparent',
        }}
      >
        {/* <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between"> */}
        <div className="max-w-6xl mx-auto py-4 flex items-center justify-between">
          
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center shadow-md group-hover:scale-105 transition-transform">
              <span className="text-white text-xl">🍱</span>
            </div>

            <div>
              <div className="font-display text-amber-900 text-lg leading-none">
                BSM Bhojan Seva Mandal
              </div>
              <div className="text-xs text-amber-600 tracking-widest uppercase">
                Foundation
              </div>
            </div>
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-8">
            {links.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`nav-link ${
                  location.pathname === to ? 'active' : ''
                }`}
              >
                {label}
              </Link>
            ))}

            <a
              href="https://rzp.io/rzp/bhojanseva-mandal"
              rel="noopener noreferrer"
              className="btn-primary py-2 px-6 text-xs"
            >
              {/* Donate */}Membership
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span
              className={`block w-6 h-0.5 bg-amber-800 transition-transform duration-200 ${
                menuOpen ? 'translate-y-2 rotate-45' : ''
              }`}
            />

            <span
              className={`block w-6 h-0.5 bg-amber-800 transition-opacity duration-200 ${
                menuOpen ? 'opacity-0' : ''
              }`}
            />

            <span
              className={`block w-6 h-0.5 bg-amber-800 transition-transform duration-200 ${
                menuOpen ? '-translate-y-2 -rotate-45' : ''
              }`}
            />
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden bg-white/90 backdrop-blur-xl border-t border-amber-200/50 px-6 py-4 flex flex-col gap-4 rounded-b-2xl shadow-lg">
            {links.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`nav-link text-lg ${
                  location.pathname === to ? 'active' : ''
                }`}
              >
                {label}
              </Link>
            ))}
        
            <a
              href="https://rzp.io/rzp/bsm-bhojanseva-mandal"
              rel="noopener noreferrer"
              className="btn-primary text-center"
            >
              {/* Donate */}Membership
            </a>
          </div>
        )}
      </nav>

    </>
  );
}